<template>
	<div>
		<div v-if="this.product.cancellation_request">
			<div v-if="this.product.cancellation_request_status === 3 || this.accepted">
				<vs-chip color="danger">
					<vx-tooltip text="Annuleer verzoek geaccepteerd.">
						Product geannuleerd
					</vx-tooltip>
				</vs-chip>
			</div>

			<div v-else-if="this.product.cancellation_request_status === 1">
				<vs-chip id="acceptCancelRequestLoading" closable @click.native="acceptCancelRequest" color="warning">
					<vx-tooltip text="Klant heeft een annuleer verzoek ingediend.">
						Annuleer verzoek
					</vx-tooltip>
				</vs-chip>
			</div>
		</div>

		<div v-else>
			<vs-chip v-if="this.product.condition === 'NEW'">
				<vx-tooltip text="Product conditie" position="top">
					Nieuw
				</vx-tooltip>
			</vs-chip>
			<vs-chip v-if="this.product.condition === 'AS_NEW'">
				<vx-tooltip text="Product conditie" position="top">
					Gebruikt > Als nieuw
				</vx-tooltip>
			</vs-chip>
			<vs-chip v-if="this.product.condition === 'GOOD'">
				<vx-tooltip text="Product conditie" position="top">
					Gebruikt > Goed
				</vx-tooltip>
			</vs-chip>
			<vs-chip v-if="this.product.condition === 'REASONABLE'">
				<vx-tooltip text="Product conditie" position="top">
					Gebruikt > Redelijk
				</vx-tooltip>
			</vs-chip>
			<vs-chip v-if="this.product.condition === 'MODERATE'">
				<vx-tooltip text="Product conditie" position="top">
					Gebruikt > Matig
				</vx-tooltip>
			</vs-chip>
		</div>
	</div>
</template>

<script>
import apiClient from '@/services/apiClient';

export default {
	props: {
		order: {
			type: Object,
			required: true
		},
		product: {
			type: Object,
			required: true,
		}
	},
	data() {
		return {
			accepted: this.cancelAccepted,
			reason: this.cancelReason,
		}
	},
	methods: {
		acceptCancelRequest() {
			this.$vs.dialog({
				type: 'confirm',
				color: 'warning',
				title: 'Accepteer annuleer verzoek',
				text: 'Weet je zeker dat je dit annuleer verzoek wilt accepteren?',
				accept: this.markRequestAccepted,
				acceptText: 'Ja',
				cancelText: 'Nee'
			});
		},
		markRequestAccepted() {
			this.$vs.loading({
				container: '#acceptCancelRequestLoading',
				scale: 0.45
			})

			if (!this.reason) {
				this.reason = 'REQUESTED_BY_CUSTOMER';
			}
			const params = {
				order_item_id: this.product.id,
				cancel: true,
				cancel_reason: this.reason,
			}

			apiClient.put('orders/items/update', params).then(response => {
				this.$vs.notify({
					title: 'Gelukt!',
					text: 'Bestelling is succesvol geannuleerd!',
					color: 'success'
				});

				apiClient.get('orders/get/order', {params: {order_id: this.order.order.id}}).then(response => {
					this.$vs.loading.close('#acceptCancelRequestLoading > .con-vs-loading');

					this.$store.dispatch('openOrdersStore/updateOrder', response.data).then(() => {
						if (this.order.order.status === 4) {
							setTimeout(() => {
								this.$store.dispatch('openOrdersStore/removeOrder', this.order);
							}, 1000);
						}
					});
				}).catch(error => {
					this.$vs.notify({
						title: 'Oops!',
						text: 'Het vernieuwen van de bestelling is mislukt',
						color: 'danger'
					});
				})
			}).catch(error => {
				this.$vs.notify({
					title: 'Oops!',
					text: 'Er is iets fout gegaan probeer het later nog een keer.',
					color: 'danger'
				})
			});
		}
	}
}
</script>
